/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";
import parse from 'html-react-parser';
import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import $ from "jquery";

import ApplicationApiContext from "@Contexts/Api";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import USER_INTERFACE from "@Services/Application/Interfaces/Users/User";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import {ERROR_SYSTEM_MESSAGE_INTERFACE} from "@Services/Application/Interfaces/_Messages/Errors";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import {Redirect, NavLink} from "react-router-dom";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import {Col} from "react-bootstrap";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";

type RegulationsPageProps = {};


export const SettingsRegulationsPageComponent: React.FC<RegulationsPageProps> = (): JSX.Element | null => {


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @const {React.Ref} My Favourite Terminals Page Container DOM Ref */
    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    /** @var {[object, function]} State - User Profile Data Object, User Profile Data Object Setter */
    const [USER_REGULATIONS, SET_USER_REGULATIONS] = useState<[] | null>(null);
    /** @var {[boolean, function]} State - User Profile Component Error, User Profile Component Error Setter */
    const [USER_REGULATIONS_ERROR, SET_USER_REGULATIONS_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    const [USER_REGULATION_DOCUMENT, SET_USER_REGULATION_DOCUMENT] = useState<any>(null);

    /** @hook {didMount, didUpdate} Get Terminals List from REST API */
    useEffect(() => {

        // if (!userVerifiedStatus) return;

        /* Check if Monitory Note ID, API URL Present, User Logged */
        if (!REST_API_URL || !LOGGED_USER?.userID) return; // No Valid Data - Stop

        const USER_REGULATIONS_API_URL: string = REST_API_URL + "/App/Regulation/List";

        const USER_REGULATIONS_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID, // Logged User ID
        };

        const GET_USER_REGULATIONS = async (): Promise<void | Function> => {

            try {

                const REGULATIONS_RESPONSE = await REST_API_REQUEST(
                    USER_REGULATIONS_API_URL,
                    USER_REGULATIONS_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (REGULATIONS_RESPONSE.status === 200) {
                    const CONTENT = await REGULATIONS_RESPONSE.text();
                    if (CONTENT.trim()) {
                        SET_USER_REGULATIONS(JSON.parse(CONTENT).Regulations);
                    }
                } else {
                    if (REGULATIONS_RESPONSE.status === 409) {
                        const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await REGULATIONS_RESPONSE.json();
                        SET_USER_REGULATIONS_ERROR({ErrorCode: CONTENT.ErrorCode, UserMessage: CONTENT.UserMessage});
                    } else {
                        SET_USER_REGULATIONS_ERROR({ErrorCode: REGULATIONS_RESPONSE.status, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
                    }
                }

            } catch (e) {
                SET_USER_REGULATIONS_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_USER_REGULATIONS();

    }, []);

    useEffect(() => {
        return () => {SET_USER_REGULATIONS_ERROR(null);};
    }, [])


    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL}/>;


    if (!ROUTER) return <Redirect to={"/404"}/>;


    const GET_REGULATION_FILE_HANDLER = async (regulationId: number) => {

        if (!regulationId) return;

        const REGULATION_API_URL = `${REST_API_URL}/App/Regulation/Get/Docs`;

        const REGULATION_REQUEST_DATA = {UserId: LOGGED_USER?.userID, RegulationId: regulationId};

        try {
            const newWindow = window.open();

            const REGULATION_RESPONSE = await REST_API_REQUEST(
                REGULATION_API_URL,
                REGULATION_REQUEST_DATA,
                REST_API_REQUEST_TOKEN
            );

            if (REGULATION_RESPONSE.status === 200) {

                const CONTENT: any = await REGULATION_RESPONSE.json();

                if (!CONTENT?.Docs[0]?.DocData) return;

                const binaryString = window.atob(CONTENT.Docs[0].DocData);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; ++i) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                const PDF = new Blob([bytes], {type: 'application/pdf'});

                const PDF_URL = URL.createObjectURL(PDF);
                
                if(newWindow) newWindow.location = PDF_URL;

            } else {
                const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await REGULATION_RESPONSE.json();
                SET_USER_REGULATIONS_ERROR({ErrorCode: REGULATION_RESPONSE.status, UserMessage: CONTENT.UserMessage})
            }

        } catch (e) {
            SET_USER_REGULATIONS_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
        }

    };


    const RegulationsList = USER_REGULATIONS?.map((REGULATION: any) =>
        {
            return (
                <Col key={REGULATION.RegulationId} xs={12} className={"regulations-list-element"}>
                    <NavLink to={`/`} title={REGULATION.Name} onClick={(e) => {e.preventDefault(); GET_REGULATION_FILE_HANDLER(REGULATION.RegulationId)}}>
                        <span>{REGULATION.Name}</span>
                    </NavLink>
                </Col>
            );
        }
    ) || null;


    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"settings-page-information-data-component regulations-page regulations-page-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Regulaminy i klauzule"} />

            {!!USER_REGULATIONS_ERROR && <ErrorMessageComponent messageText={USER_REGULATIONS_ERROR.UserMessage} />}

            {!!USER_REGULATIONS && USER_REGULATIONS?.length < 1 ?
            <Col xs={12} className={"no-list-elements-message default-system-message"}>
                <span>{`Brak regulaminów`}</span>
            </Col>
            :
            RegulationsList
            }

        </BlockContentContainerComponent>
    );

}


export default SettingsRegulationsPageComponent;
